import Logo from "@/components/Logo";
import { useIsABTest } from "@/hooks/useIsABTest";
import { clsxm } from "@/utils/clsxm";
import { Reviews } from "@/pages/quiz/base/components/footerAB/components/reviews";
import { ABTest10USPDesktop } from "@/pages/quiz/base/components/header/components/ABTest10USPDesktop";
import { ABTest10USPMobile } from "@/pages/quiz/base/components/header/components/ABTest10USPMobile";

const Header = () => {
  const { isABTest_10_1_USP, isABTest_10_2_USP } = useIsABTest();

  return (
    <header>
      <div
        className={clsxm(
          "min-h-20 flex flex-col justify-center items-center bg-dark-purple-2",
          (isABTest_10_1_USP || isABTest_10_2_USP) && "bg-main-button-v2",
          isABTest_10_2_USP && "gap-y-2 py-2 lg:px-6"
        )}
      >
        <Logo
          wrapperClassName={clsxm(
            "text-white max-w-[150px]",
            isABTest_10_2_USP &&
              "max-w-[90px] lg:max-w-[150px] lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2"
          )}
        />

        {isABTest_10_2_USP && <Reviews t10_2 />}
      </div>

      {(isABTest_10_1_USP || isABTest_10_2_USP) && (
        <>
          <ABTest10USPMobile t10_2={isABTest_10_2_USP} />
          <ABTest10USPDesktop t10_2={isABTest_10_2_USP} />
        </>
      )}
    </header>
  );
};

export { Header };
